/* Collectie Slider -- sliderbar, kleurstalen en favorieten.
   Sentir Parfum. Hoort bij collectie-slider.css. Zie
   design_handoff_collectie_slider/README.md.

   Overgenomen uit de handoff, zonder het renderdeel: in het thema tekent Liquid
   de kaarten (README paragraaf 6.1). Wat overblijft zijn de drie gedragsblokken
   -- SLIDERBAR, KLEURSTALEN, FAVORIETEN -- plus twee koppelingen die de demo
   niet had: de mandjesknop en het hartje.

   Het sliderbar-blok is letterlijk overgenomen. De twee vangnetten in sync()
   staan er met opzet in: de nulmaat-check voorkomt een NaN-breedte waardoor de
   bar voorgoed verborgen blijft, en de rAF-staart in follow() dekt af dat het
   scroll-event niet bij elke wijziging komt. Niet weghalen.

   Wat hier anders is dan in de demo:
   - de geuren van varianten komen uit <script type="application/json"
     data-variants> per sectie, in plaats van uit window.SLIDER_DATA;
   - klikken wordt op document afgevangen in plaats van op een #sections-div,
     want in het thema zijn dit losse secties;
   - de knop "In mijn mandje" legt de variant in het mandje via SentirCart, het
     bestaande mandje van dit thema, en opent de drawer zoals overal elders. */

(function () {
  'use strict';

  /* Per variant: foto, hoverfoto, naam en prijs. De sectie schrijft dit weg. */
  const BY_ID = {};
  document.querySelectorAll('[data-variants]').forEach((holder) => {
    try {
      (JSON.parse(holder.textContent) || []).forEach((v) => {
        BY_ID[String(v.id)] = v;
      });
    } catch (error) {
      /* Stil: zonder deze gegevens wisselen de stalen niet, maar de rest werkt. */
    }
  });

  document.querySelectorAll('.coll').forEach(sec => {
    const rail = sec.querySelector('.rail');
    const track = sec.querySelector('.strack');
    const thumb = sec.querySelector('.sthumb');
    const prev = sec.querySelector('.sprev');
    const next = sec.querySelector('.snext');

    function maxScroll(){ return rail.scrollWidth - rail.clientWidth; }
    function sync(){
      // vóór de eerste layout zijn alle maten 0; dan niets aanraken, anders wordt
      // 0/0 als NaN-breedte weggeschreven en blijft de bar verborgen staan
      if (!rail.scrollWidth || !track.clientWidth) return;
      const max = maxScroll();
      // onder de 1px is er niets te slepen: de bar verdwijnt in plaats van vol te staan
      track.parentElement.style.visibility = max <= 1 ? 'hidden' : '';
      const frac = rail.clientWidth / rail.scrollWidth;
      let tw = Math.max(28, track.clientWidth * frac);
      if (!Number.isFinite(tw)) tw = track.clientWidth;
      thumb.style.width = tw + 'px';
      thumb.style.transform = 'translateX(' + (max > 0 ? (rail.scrollLeft / max) * (track.clientWidth - tw) : 0) + 'px)';
      if (prev) prev.disabled = rail.scrollLeft <= 1;
      if (next) next.disabled = rail.scrollLeft >= max - 1;
    }
    // de scroll van de rail is de enige bron van waarheid, maar het scroll-event
    // komt niet bij elke wijziging; een korte rAF-staart dekt smooth scrollen,
    // toetsenbordnavigatie en de pijlknoppen af
    let raf = 0, until = 0;
    function follow(ms){
      until = performance.now() + (ms || 700);
      if (raf) return;
      const tick = () => {
        sync();
        raf = performance.now() < until ? requestAnimationFrame(tick) : 0;
      };
      raf = requestAnimationFrame(tick);
    }
    function step(dir){
      const card = rail.querySelector('.card');
      const w = card ? card.getBoundingClientRect().width + 12 : 300;
      // met hele kaarten opschuiven, minstens één, maximaal een zichtbare rij
      const n = Math.max(1, Math.floor(rail.clientWidth / w));
      rail.scrollBy({ left: dir * n * w, behavior:'smooth' });
    }

    rail.addEventListener('scroll', () => { sync(); follow(220); }, { passive:true });
    rail.addEventListener('keydown', () => follow());
    if (prev) prev.addEventListener('click', () => { step(-1); follow(); });
    if (next) next.addEventListener('click', () => { step(1); follow(); });

    // slepen: positie volgt de cursor over de resterende trackbreedte
    let drag = false;
    function seek(clientX){
      const tw = thumb.getBoundingClientRect().width;
      const r = track.getBoundingClientRect();
      const room = r.width - tw;
      const k = room > 0 ? Math.max(0, Math.min(1, (clientX - r.left - tw / 2) / room)) : 0;
      rail.scrollLeft = k * maxScroll();
    }
    track.addEventListener('pointerdown', e => {
      drag = true; track.setPointerCapture(e.pointerId);
      rail.style.scrollBehavior = 'auto'; seek(e.clientX); sync();
    });
    track.addEventListener('pointermove', e => { if (drag){ seek(e.clientX); sync(); } });
    track.addEventListener('pointerup', () => { drag = false; rail.style.scrollBehavior = ''; });
    track.addEventListener('pointercancel', () => { drag = false; rail.style.scrollBehavior = ''; });

    const ro = new ResizeObserver(sync);
    ro.observe(rail); ro.observe(track);
    // de packshots bepalen de kaarthoogte, niet de breedte, maar de rail kan er
    // wel door verschuiven — dus ook na het laden van de plaatjes nog een keer
    requestAnimationFrame(sync);
    addEventListener('load', sync);
    rail.querySelectorAll('img').forEach(im => {
      if (!im.complete) im.addEventListener('load', sync, { once:true });
    });
    sync();
  });

  /* De pijl naar links is dezelfde chevron, gespiegeld. Stond in de demo in het
     renderdeel; dat is hier weg, dus doet het script het na het tekenen. */
  document.querySelectorAll('.sprev svg').forEach((s) => { s.style.transform = 'scaleX(-1)'; });

  /* -- favorieten: hartje + notificatiebalk onder de navigatie -- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.fav');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    const card = b.closest('.card');
    if (!card) return;
    const id = card.dataset.id;
    const on = !b.classList.contains('on');
    /* Alle kaarten met deze variant, want een variant kan in twee rijen staan. */
    document.querySelectorAll('.fav').forEach((el) => {
      const c = el.closest('.card');
      if (c && c.dataset.id === id) el.classList.toggle('on', on);
    });
    dispatchEvent(new CustomEvent('sentir:list-toast', { detail: { list: 'fav', added: on } }));
  });

  /* -- swatch: dezelfde kaart, andere variant -- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.sw button');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    const card = b.closest('.card');
    const p = BY_ID[b.dataset.sw];
    if (!card || !p) return;
    card.dataset.id = p.id;
    /* De kaart linkt daarna naar de gekozen variant. */
    if (p.url) card.setAttribute('href', p.url);
    const main = card.querySelector('.ph img:first-of-type');
    if (main) {
      main.className = p.fit === 'pack' ? 'i-pack' : 'i-cover';
      main.src = p.img; main.alt = p.nm;
    }
    const hov = card.querySelector('.hov-img');
    if (hov) {
      /* Zonder hoverfoto blijft de wissel achterwege in plaats van een gat. */
      if (p.hov) { hov.src = p.hov; hov.hidden = false; }
      else { hov.removeAttribute('src'); hov.hidden = true; }
    }
    const nm = card.querySelector('.nm');
    if (nm) nm.textContent = p.nm;
    const pr = card.querySelector('.pr');
    if (pr) pr.innerHTML = (p.was ? '<s class="was">' + p.was + '</s>' : '') + '<span class="now">' + p.price + '</span>';
    const atc = card.querySelector('.atc');
    if (atc) atc.dataset.variant = p.id;
    card.querySelectorAll('.sw button').forEach((x) => {
      x.setAttribute('aria-pressed', String(x.dataset.sw === String(p.id)));
    });
  });

  /* -- in mijn mandje: de variant, niet het product -- */
  document.addEventListener('click', (e) => {
    const knop = e.target.closest('.atc');
    if (!knop) return;
    /* De kaart is een link; zonder dit navigeert de klik ook naar het product. */
    e.preventDefault(); e.stopPropagation();

    const id = knop.dataset.variant;
    if (!id || knop.disabled) return;

    if (!window.SentirCart || typeof window.SentirCart.add !== 'function') {
      /* Zonder het mandje van het thema valt het terug op de gewone formulierweg. */
      window.location.href = '/cart/add?id=' + encodeURIComponent(id) + '&quantity=1';
      return;
    }

    knop.disabled = true;
    window.SentirCart.add({ items: [{ id: Number(id), quantity: 1 }] }, { trigger: knop })
      .catch(() => {})
      .then(() => { knop.disabled = false; });
  });

  /* Klikken op de kaart zelf mag wel navigeren; alleen de knoppen erin niet. */
})();
